// Who works one step (spec J3, §5.1 step assignees): their names on the step, and for people who
// may re-plan an "Assign" button that opens the people picker (PUT .../steps/:no/assignees).
import { useState } from 'react';
import type { TaskDetail, TaskStep } from '@cis/api-client';
import { AssignDialog } from './assign-dialog.tsx';
import type { TaskWriter } from './use-task-writer.ts';

export function StepAssignees(props: {
  readonly step: TaskStep;
  readonly detail: TaskDetail;
  readonly writer: TaskWriter;
  readonly canAssign: boolean;
}): React.JSX.Element | null {
  const { step, writer, canAssign } = props;
  const [open, setOpen] = useState(false);
  const names = step.assignees.map((p) => p.displayName).join(', ');
  if (names === '' && !canAssign) return null;
  const label = `step ${String(step.no)}`;
  return (
    <div className="form-row">
      <p className="muted">Step assigned to: {names === '' ? 'same as the task' : names}</p>
      {canAssign && (
        <button
          type="button"
          className="btn btn--secondary"
          aria-label={`Assign ${label}`}
          disabled={writer.pending}
          onClick={() => setOpen(true)}
        >
          Assign
        </button>
      )}
      {open && (
        <AssignDialog
          title={`Assign ${label}`}
          detail={props.detail}
          assigned={(d) => d.steps.find((s) => s.no === step.no)?.assignees ?? []}
          writer={writer}
          toWrite={(userIds) => ({ kind: 'assign-step', stepNo: step.no, userIds })}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
}
